import { RecommendationType } from '@/@types';
import { useUser } from '@/components/context/user';
import { useCallback, useState } from 'react';
import clsx from 'clsx';
import * as styles from './use-likes.styles';

const useLike = (comment?: RecommendationType) => {
  const [animate, setAnimate] = useState(false);
  const { api, isLogged } = useUser();
  const [likes, setLikes] = useState(comment?.likes?.total || 0);

  const like = useCallback(() => {
    if (!comment || !isLogged) {
      return;
    }
    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
    }, 250);
    const prev = likes;
    setLikes(likes + 1);
    api.like(comment.id).catch(() => {
      setLikes(prev);
    });
  }, [likes, api, comment, isLogged]);

  return [likes, like, clsx({ [styles.animateLike]: animate })] as [likes: number, like: () => any, animationClassNames: string];
};

export default useLike;
